import { useEffect, useState } from 'react';
import './Preloader.css';

export function Preloader({ isDataLoaded }: { isDataLoaded: boolean }) {
  const [phase, setPhase] = useState<'waiting' | 'drawing' | 'holding' | 'splitting' | 'done'>('waiting');

  useEffect(() => {
    // 1. Silent tension
    const t1 = setTimeout(() => setPhase('drawing'), 500);
    return () => clearTimeout(t1);
  }, []);

  useEffect(() => {
    // 2. The blade draws deliberately from one end to another (pure art)
    if (phase === 'drawing') {
      const t2 = setTimeout(() => setPhase('holding'), 1000); 
      return () => clearTimeout(t2);
    }
  }, [phase]);

  useEffect(() => {
    // 3. Hold until data is loaded
    if (phase === 'holding') {
      const minHold = 500; 
      const startTime = Date.now();
      
      let animationFrameId: number;
      const checkState = () => {
        if (isDataLoaded && (Date.now() - startTime) >= minHold) {
          setPhase('splitting');
        } else {
          animationFrameId = requestAnimationFrame(checkState);
        }
      };
      
      animationFrameId = requestAnimationFrame(checkState);
      return () => cancelAnimationFrame(animationFrameId);
    }
  }, [phase, isDataLoaded]);

  useEffect(() => {
    // 4. The SVG filter tears the screen apart organically
    if (phase === 'splitting') {
      const t4 = setTimeout(() => setPhase('done'), 2200);
      return () => clearTimeout(t4);
    }
  }, [phase]);

  if (phase === 'done') return null;

  return (
    <div className={`cyber-preloader ${phase}`}>
      
      <svg className="svg-filters" width="0" height="0" style={{ position: 'absolute' }}>
        <filter id="void-burn" x="-50%" y="-50%" width="200%" height="200%">
          <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="3" result="noise" />
          <feDisplacementMap 
            in="SourceGraphic" 
            in2="noise" 
            scale={phase === 'splitting' ? "0" : "0"} 
            xChannelSelector="R" 
            yChannelSelector="G"
          >
            {phase === 'splitting' && (
              <animate attributeName="scale" from="0" to="350" dur="2.2s" fill="freeze" />
            )}
          </feDisplacementMap>
        </filter>
      </svg>

      <div className="preloader-half top"></div>
      <div className="preloader-half bottom"></div>
      
      <div className="katana-wrapper">
        <div className="ember-blade"></div>
      </div>
    </div>
  );
}
